// extracted by mini-css-extract-plugin
export default {"footerBox":"Footer_footerBox__ynLr9","footerTitleBox":"Footer_footerTitleBox__IufiX","helpContainer":"Footer_helpContainer__xunt9"};